<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <img src="assets/icons/Settings/warning.svg">
      <h2 class="modal-title" id="modal-basic-title">
        @if (!description) {
          {{ 'setting-delete-title-modal' | translate }} {{ parameter }}
        } @else {
          {{ 'setting-delete-title-modal-description' | translate }} {{ parameter }}
        }
      </h2>
    </div>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      @if (!key) {
        <input class="form-control" [placeholder]="vtodelete" readonly>
      } @else {
        <div class="d-flex flex-row align-items-center">
          <input class="form-control keyF" [(ngModel)]="key" readonly>
          <h3> : </h3>
          <input class="form-control valueF" [(ngModel)]="vtodelete" readonly>
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="confirmDelete();c('Save click');">
      {{ 'confirm' | translate }}
    </button>
  </div>
</ng-template>

@if (!description) {
  <img type="button" (click)="open({ content: content })" class="delete" src="assets/icons/Policies/cross.svg">
}
@if (description) {
  <img type="button" (click)="open({ content: content })" class="descriptionD" src="assets/icons/Policies/cross.svg">
}